<template>
  <div class="qiyu-customer-service">
    <!-- error status display -->
    <div v-if="initError" class="qiyu-error">
      <p>客服系统暂时不可用</p>
    </div>

    <!-- loading status display -->
    <div v-else-if="isInitializing" class="qiyu-loading">
      <p>正在初始化客服系统...</p>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'QiyuCustomerService',
  mixins: [mixin],

  async mounted() {
    console.log('QiyuCustomerService mounted')

    try {
      // 1. get cookies params
      this.getParamsByCookies()

      // 2. get parent info and robot config in parallel [old]
      // const [parentInfo, latestRobot] = await Promise.allSettled([
      //   this.getParentInfo(),
      //   this.getLatestRobot(),
      // ])

      // handle results [old]
      // if (parentInfo.status === 'fulfilled') {
      //   this.parentInfo = parentInfo.value || {}
      // }

      // if (latestRobot.status === 'fulfilled') {
      //   this.latestRobot = latestRobot.value || ''
      // }

      // 3. initialize qiyu customer service
      await this.initQiyu()
    } catch (error) {
      console.error('QiyuCustomerService init failed:', error)
      this.initError = error
    }
  },
}
</script>

<style scoped>
.qiyu-customer-service {
  position: relative;
}

.qiyu-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  font-size: 12px;
  color: #ff4d4f;
}

.qiyu-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
  font-size: 12px;
  color: #52c41a;
}

</style>
